import _filter from "lodash/filter";
import _flatMap from "lodash/flatMap";
import _toLower from "lodash/toLower";
import { IFacet, IGetFacetsResponse } from "shared-types/src/Facets";

export function getFacetListByType(
  facetResponse: IGetFacetsResponse,
  systemNames: string | string[]
): IFacet[] {
  const names = (Array.isArray(systemNames) ? systemNames : [systemNames]).map(
    _toLower
  );

  if (names.length === 0) {
    return [];
  }

  const matchedGroups = _filter(facetResponse, (facetGroup) =>
    names.includes(_toLower(facetGroup.systemName))
  );

  return (
    _flatMap(matchedGroups, (group) => _flatMap(group.facetGroups, "facets")) ||
    []
  );
}
